import { useState, useMemo } from "react";

const allCities = [
  {
    name: "Ann Arbor",
    route: "/ann-arbor",
    tagline: "Washtenaw County expedited passport services near the University of Michigan campus",
    highlights: ["College town coverage", "Serving Ypsilanti, Chelsea, Saline"],
    badge: null,
    status: "live",
  },
  {
    name: "Battle Creek",
    route: "/cities/battle-creek",
    tagline: "Calhoun County expedited passport processing for Southwest Michigan travelers",
    highlights: ["Southwest Michigan coverage", "Serving Marshall, Albion, Springfield"],
    badge: null,
    status: "live",
  },
  {
    name: "Bay City",
    route: "/cities/bay-city",
    tagline: "Bay County expedited passport services on the Saginaw Bay near Lake Huron",
    highlights: ["Great Lakes Bay coverage", "Serving Essexville, Auburn, Linwood"],
    badge: null,
    status: "live",
  },
  {
    name: "Dearborn",
    route: "/cities/dearborn",
    tagline: "Wayne County expedited passport services near the Ford Motor Company headquarters",
    highlights: ["Detroit metro coverage", "Serving Dearborn Heights, Melvindale, Allen Park"],
    badge: null,
    status: "live",
  },
  {
    name: "Detroit",
    route: "/cities/detroit",
    tagline: "Michigan's largest expedited passport hub for Motor City travelers",
    highlights: ["Wayne County wide coverage", "Serving Downtown, Midtown, Corktown"],
    badge: "Most Popular",
    status: "live",
  },
  {
    name: "Flint",
    route: "/flint",
    tagline: "Genesee County expedited passport processing for Mid-Michigan travelers",
    highlights: ["Mid-Michigan coverage", "Serving Burton, Grand Blanc, Fenton"],
    badge: null,
    status: "live",
  },
  {
    name: "Grand Haven",
    route: "/cities/grand-haven",
    tagline: "Ottawa County coastal city — expedited passport services at the mouth of the Grand River and Lake Michigan shore",
    highlights: ["Lake Michigan coast coverage", "Serving Spring Lake, Ferrysburg, Coopersville"],
    badge: null,
    status: "live",
  },
  {
    name: "Grand Rapids",
    route: "/grand-rapids",
    tagline: "Kent County expedited passport hub on the Grand River for West Michigan",
    highlights: ["West Michigan coverage", "Serving Wyoming, Kentwood, Walker"],
    badge: "Popular",
    status: "live",
  },
  {
    name: "Holland",
    route: "/cities/holland",
    tagline: "Ottawa County expedited passport services near Lake Michigan's eastern shore",
    highlights: ["Lake Michigan coast coverage", "Serving Zeeland, Hudsonville, Saugatuck"],
    badge: null,
    status: "live",
  },
  {
    name: "Jackson",
    route: "/cities/jackson-mi",
    tagline: "Jackson County expedited passport processing for South Central Michigan",
    highlights: ["South Central Michigan coverage", "Serving Parma, Spring Arbor, Michigan Center"],
    badge: null,
    status: "live",
  },
  {
    name: "Kalamazoo",
    route: "/cities/kalamazoo",
    tagline: "Kalamazoo County expedited passport services near Western Michigan University",
    highlights: ["Southwest Michigan coverage", "Serving Portage, Comstock, Parchment"],
    badge: null,
    status: "live",
  },
  {
    name: "Lansing",
    route: "/lansing-mi",
    tagline: "Ingham County expedited passport hub for the Michigan state capital",
    highlights: ["Capital region coverage", "Serving East Lansing, Okemos, Haslett"],
    badge: null,
    status: "live",
  },
  {
    name: "Livonia",
    route: "/cities/livonia",
    tagline: "Wayne County expedited passport services in Western Detroit metro",
    highlights: ["Detroit metro coverage", "Serving Westland, Canton, Redford, Farmington"],
    badge: null,
    status: "live",
  },
  {
    name: "Midland",
    route: "/cities/midland",
    tagline: "Midland County expedited passport processing near Dow Chemical and Dow Gardens",
    highlights: ["Central Michigan coverage", "Serving Auburn, Sanford, Edenville"],
    badge: null,
    status: "live",
  },
  {
    name: "Monroe",
    route: "/cities/monroe",
    tagline: "Monroe County expedited passport services near the Ohio border on Lake Erie",
    highlights: ["Southeast Michigan coverage", "Serving Dundee, Lambertville, Temperance"],
    badge: null,
    status: "live",
  },
  {
    name: "Muskegon",
    route: "/cities/muskegon",
    tagline: "Muskegon County expedited passport services on the Lake Michigan shore",
    highlights: ["West Michigan coast coverage", "Serving Norton Shores, Roosevelt Park, Fruitport"],
    badge: null,
    status: "live",
  },
  {
    name: "Pontiac",
    route: "/cities/pontiac",
    tagline: "Oakland County expedited passport processing in the northern Detroit suburbs",
    highlights: ["Oakland County coverage", "Serving Auburn Hills, Waterford, Bloomfield"],
    badge: null,
    status: "live",
  },
  {
    name: "Port Huron",
    route: "/cities/port-huron",
    tagline: "St. Clair County expedited passport services on the Blue Water Bridge to Canada",
    highlights: ["Blue Water area coverage", "Serving Marysville, Fort Gratiot, Marine City"],
    badge: null,
    status: "live",
  },
  {
    name: "Royal Oak",
    route: "/cities/royal-oak",
    tagline: "Oakland County expedited passport services in the Woodward Avenue corridor",
    highlights: ["Oakland County coverage", "Serving Berkley, Madison Heights, Ferndale, Clawson"],
    badge: null,
    status: "live",
  },
  {
    name: "Saginaw",
    route: "/cities/saginaw",
    tagline: "Saginaw County expedited passport processing in the Great Lakes Bay region",
    highlights: ["Great Lakes Bay coverage", "Serving Saginaw Township, Bridgeport, Buena Vista"],
    badge: null,
    status: "live",
  },
  {
    name: "Sterling Heights",
    route: "/cities/sterling-heights",
    tagline: "Macomb County expedited passport services in the northern Detroit suburbs",
    highlights: ["Macomb County coverage", "Serving Shelby, Utica, Clinton, Fraser"],
    badge: null,
    status: "live",
  },
  {
    name: "Traverse City",
    route: "/cities/traverse-city",
    tagline: "Grand Traverse County expedited passport hub in Northern Michigan wine country",
    highlights: ["Northern Michigan coverage", "Serving Acme, Garfield, Blair"],
    badge: "Popular",
    status: "live",
  },
  {
    name: "Troy",
    route: "/cities/troy-mi",
    tagline: "Oakland County expedited passport services in the northern Detroit business corridor",
    highlights: ["Oakland County coverage", "Serving Birmingham, Clawson, Rochester Hills"],
    badge: null,
    status: "live",
  },
  {
    name: "Clinton Township",
    route: "/cities/clinton-township",
    tagline: "Macomb County expedited passport services in the northern Detroit suburbs near Mount Clemens",
    highlights: ["Macomb County coverage", "Serving Mount Clemens, Fraser, Shelby Township, Utica"],
    badge: null,
    status: "live",
  },
  {
    name: "Eastpointe",
    route: "/cities/eastpointe",
    tagline: "Western Macomb County expedited passport services on the Detroit border",
    highlights: ["Detroit border coverage", "Serving Roseville, Warren, Saint Clair Shores"],
    badge: null,
    status: "live",
  },
  {
    name: "Roseville",
    route: "/cities/roseville-mi",
    tagline: "Macomb County expedited passport services in the Gratiot Avenue corridor",
    highlights: ["Macomb County coverage", "Serving Eastpointe, Clinton Township, Saint Clair Shores"],
    badge: null,
    status: "live",
  },
  {
    name: "Saint Clair Shores",
    route: "/cities/saint-clair-shores",
    tagline: "Macomb County expedited passport services on the Lake Saint Clair Nautical Mile waterfront",
    highlights: ["Eastern Macomb County coverage", "Serving Warren, Roseville, Eastpointe, Grosse Pointe"],
    badge: null,
    status: "live",
  },
  {
    name: "Warren",
    route: "/cities/warren",
    tagline: "Macomb County expedited passport processing in the Detroit metro area",
    highlights: ["Macomb County coverage", "Serving Center Line, Roseville, Eastpointe"],
    badge: null,
    status: "live",
  },
  {
    name: "Wyoming",
    route: "/states/wyoming",
    tagline: "Kent County expedited passport services in the southwest Grand Rapids metro",
    highlights: ["28th Street corridor coverage", "Serving Grandville, Byron Center, Caledonia"],
    badge: null,
    status: "live",
  },
  {
    name: "Ypsilanti",
    route: "/cities/ypsilanti",
    tagline: "Washtenaw County expedited passport services near Eastern Michigan University",
    highlights: ["College town coverage", "Serving Pittsfield, Superior, Willow Run"],
    badge: null,
    status: "live",
  },
  {
    name: "Sault Ste. Marie",
    route: "/cities/sault-ste-marie",
    tagline: "Chippewa County expedited passport services at the Canadian border crossing",
    highlights: ["Eastern Upper Peninsula coverage", "Serving Rudyard, Brimley, Dafter"],
    badge: null,
    status: "live",
  },
  {
    name: "Marquette",
    route: "/cities/marquette",
    tagline: "Marquette County expedited passport processing in Northern Michigan Upper Peninsula",
    highlights: ["Central Upper Peninsula coverage", "Serving Negaunee, Ishpeming, Harvey"],
    badge: null,
    status: "live",
  },
  {
    name: "Petoskey",
    route: "/cities/petoskey",
    tagline: "Emmet County expedited passport services on Little Traverse Bay",
    highlights: ["Northern Lower Peninsula coverage", "Serving Harbor Springs, Bay View, Alanson"],
    badge: null,
    status: "live",
  },
  {
    name: "Ludington",
    route: "/cities/ludington",
    tagline: "Mason County expedited passport processing on the Lake Michigan shore",
    highlights: ["West Michigan coast coverage", "Serving Scottville, Custer, Pere Marquette"],
    badge: null,
    status: "live",
  },
  {
    name: "St. Joseph",
    route: "/cities/st-joseph-mi",
    tagline: "Berrien County expedited passport services on Lake Michigan near the Indiana border",
    highlights: ["Southwest Michigan coverage", "Serving Benton Harbor, Stevensville, Fair Plain"],
    badge: null,
    status: "live",
  },
  {
    name: "Adrian",
    route: "/cities/adrian",
    tagline: "Lenawee County expedited passport processing near the Ohio border",
    highlights: ["Southeast Michigan coverage", "Serving Tecumseh, Blissfield, Clinton"],
    badge: null,
    status: "live",
  },
  {
    name: "Alpena",
    route: "/cities/alpena",
    tagline: "Alpena County expedited passport services on Thunder Bay in Northeast Michigan",
    highlights: ["Northeast Michigan coverage", "Serving Ossineke, Lachine, Herron"],
    badge: null,
    status: "live",
  },
  {
    name: "Canton",
    route: "/cities/canton-mi",
    tagline: "Wayne County expedited passport services in the Detroit western suburbs",
    highlights: ["Detroit metro coverage", "Serving Plymouth, Northville, Westland, Garden City"],
    badge: null,
    status: "live",
  },
  {
    name: "Escanaba",
    route: "/cities/escanaba",
    tagline: "Delta County expedited passport processing in the Upper Peninsula on Lake Michigan",
    highlights: ["Upper Peninsula coverage", "Serving Gladstone, Bark River, Wells"],
    badge: null,
    status: "live",
  },
  {
    name: "Farmington Hills",
    route: "/cities/farmington-hills",
    tagline: "Oakland County expedited passport services in the Detroit northwest suburbs",
    highlights: ["Oakland County coverage", "Serving Novi, Southfield, Walled Lake, Wixom"],
    badge: null,
    status: "live",
  },
  {
    name: "Grand Blanc",
    route: "/cities/grand-blanc",
    tagline: "Genesee County expedited passport processing near Flint in Mid-Michigan",
    highlights: ["Mid-Michigan coverage", "Serving Fenton, Holly, Goodrich, Atlas"],
    badge: null,
    status: "live",
  },
  {
    name: "Houghton",
    route: "/cities/houghton",
    tagline: "Houghton County expedited passport services in Michigan's Upper Peninsula Keweenaw",
    highlights: ["Upper Peninsula coverage", "Serving Hancock, Michigan Tech, Calumet"],
    badge: null,
    status: "live",
  },
  {
    name: "Kentwood",
    route: "/cities/kentwood",
    tagline: "Kent County expedited passport processing near Woodland Mall in southeast Grand Rapids",
    highlights: ["44th Street corridor coverage", "Serving East Grand Rapids, Caledonia, Cutlerville"],
    badge: null,
    status: "live",
  },
  {
    name: "Manistee",
    route: "/cities/manistee",
    tagline: "Manistee County expedited passport services on the Lake Michigan shore",
    highlights: ["West Michigan coast coverage", "Serving Onekama, Bear Lake, Filer"],
    badge: null,
    status: "live",
  },
  {
    name: "Novi",
    route: "/novi",
    tagline: "Oakland County expedited passport services in the affluent Detroit northwest suburbs",
    highlights: ["Oakland County coverage", "Serving Northville, Wixom, Walled Lake, Commerce"],
    badge: null,
    status: "live",
  },
  {
    name: "Portage",
    route: "/cities/portage",
    tagline: "Kalamazoo County expedited passport processing in the Kalamazoo-Portage metro",
    highlights: ["Southwest Michigan coverage", "Serving Comstock, Oshtemo, Texas, Schoolcraft"],
    badge: null,
    status: "live",
  },
  {
    name: "Rochester Hills",
    route: "/cities/rochester-hills",
    tagline: "Oakland County expedited passport services in the northern Oakland suburbs",
    highlights: ["Oakland County coverage", "Serving Rochester, Auburn Hills, Lake Orion, Orion"],
    badge: null,
    status: "live",
  },
  {
    name: "Saginaw Township",
    route: "/cities/saginaw-township",
    tagline: "Saginaw County expedited passport processing in the Saginaw suburban area",
    highlights: ["Great Lakes Bay coverage", "Serving Freeland, Thomas, Frankenmuth"],
    badge: null,
    status: "live",
  },
  {
    name: "Southfield",
    route: "/cities/southfield",
    tagline: "Oakland County expedited passport services in the Detroit northern business corridor",
    highlights: ["Oakland County coverage", "Serving Lathrup Village, Beverly Hills, Franklin, Bingham Farms"],
    badge: null,
    status: "live",
  },
  {
    name: "Dearborn Heights",
    route: "/cities/dearborn-heights",
    tagline: "Wayne County expedited passport services between Dearborn and the western Detroit suburbs",
    highlights: ["Detroit metro coverage", "Serving Redford, Garden City, Inkster, Westland"],
    badge: null,
    status: "live",
  },
  {
    name: "Taylor",
    route: "/cities/taylor",
    tagline: "Wayne County expedited passport processing in the Detroit southern suburbs",
    highlights: ["Detroit metro coverage", "Serving Romulus, Inkster, Wayne, Garden City"],
    badge: null,
    status: "live",
  },
  {
    name: "Westland",
    route: "/cities/westland",
    tagline: "Wayne County expedited passport services in the western Detroit suburbs",
    highlights: ["Detroit metro coverage", "Serving Wayne, Garden City, Inkster, Romulus"],
    badge: null,
    status: "live",
  },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function MichiganCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Michigan Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Michigan Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        {/* Search bar */}
        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        {/* Alphabet bar */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {/* Results count */}
        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">&ldquo;{searchQuery}&rdquo;</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {/* City cards grid */}
        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Michigan</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We are always adding new Michigan locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}